import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportingService } from 'src/app/reporting/shared/services/reporting.service';
import { NgDiagramComponent, NgDiagramNodeTemplateMap, NgDiagramEdgeTemplateMap, NgDiagramPortComponent, NgDiagramConfig, initializeModel, provideNgDiagram, ModelAdapter } from 'ng-diagram';
import { AvsNodeComponent } from 'src/app/project/project-schema/shared/components/fuelcell-currents-diagram/avsNode';
import { ENodeComponent } from 'src/app/project/project-schema/shared/components/fuelcell-currents-diagram/eNode';
import { AvsEdgeComponent } from 'src/app/project/project-schema/shared/components/fuelcell-currents-diagram/avsEdge';


export interface FuelCellCurrentsDataPoint {
  deviceId: number;
  timeFuelCellDatapoint: string | undefined;
  timeSolarChargerDatapoint: string | undefined;
  generatorCurrent: number | undefined;
  solarPower: number | undefined;
  solarCurrentEqivalent: number | undefined;
  loadCurrent: number | undefined;
  chargerBatteryCurrent: number | undefined;
  fuelCellBatteryCurrent: number | undefined;
  evaCurrent: number;
}

export interface FuelCellCurrents {
  deviceName: string;
  dateDatapoints: string,
  timeFuelCellDatapoint: string;
  timeSolarChargerDatapoint: string;
  generatorCurrent: string;
  isGeneratorConsuming: boolean| undefined;
  solarPower: string;
  isSolarPowerValid : boolean;
  solarCurrentEqivalent: string;
  loadCurrent: string;
  isLoadCurrentValid : boolean;
  chargerBatteryCurrent: string;
  isFuelcellNodeConsuming: boolean | undefined;
  fuelCellBatteryCurrent: string;
  isFuelCellBatteryConsuming: boolean | undefined;
  evaCurrent: string;
  isCombinationValid: boolean;
}
enum NodeTemplateType {
  AvsNodeType = 'avsNodeType',
  ENodeType = 'eNodeType'
}

enum EdgeTemplateType {
  AvsEdgeType = 'avsEdgeType'
}
@Component({
  selector: 'avs-stromfluss-diagramm',
  standalone: true,
  templateUrl: './fuelcell-currents-diagram.component.html',
  styleUrl: './fuelcell-currents-diagram.component.css',
  imports: [NgDiagramComponent],
  providers: [provideNgDiagram()]
})

export class FuelcellCurrentsDiagramComponent implements AfterViewInit {

  nodeTemplateMap = new NgDiagramNodeTemplateMap([
    [NodeTemplateType.AvsNodeType, AvsNodeComponent],
    [NodeTemplateType.ENodeType, ENodeComponent],
  ]);
  edgeTemplateMap = new NgDiagramEdgeTemplateMap([
    [EdgeTemplateType.AvsEdgeType, AvsEdgeComponent]
  ]);

  isDiagramReady = false;
  cData: FuelCellCurrents | undefined = undefined;
  config: NgDiagramConfig = {
    zoom: {
      zoomToFit: {
        onInit: true,
        padding: 10,
      },
    },
    hideWatermark:true, 
    nodeDraggingEnabled: false,
    viewportPanningEnabled: false,
    selectionMoving:{edgePanningEnabled:false},
    resize: {defaultResizable: false}, 
 };
  model : any = undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FuelCellCurrentsDataPoint,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FuelcellCurrentsDiagramComponent>,
    private reportingService: ReportingService
  ) 
  {
    this.cData = 
    {
      deviceName: data.deviceId.toString(),
      dateDatapoints: data.timeFuelCellDatapoint != undefined ? this.formatDateFromISOString(data.timeFuelCellDatapoint):"?",
      timeFuelCellDatapoint: data.timeFuelCellDatapoint != undefined ? this.formatTimeFromISOString(data.timeFuelCellDatapoint):"?",
      timeSolarChargerDatapoint: data.timeSolarChargerDatapoint != undefined ? this.formatTimeFromISOString(data.timeSolarChargerDatapoint):"?",
      
      isGeneratorConsuming: (data.generatorCurrent != undefined && Math.abs(data.generatorCurrent) > 0.01)? data.generatorCurrent < 0 : undefined,
      generatorCurrent: data.generatorCurrent != undefined ? Math.abs(data.generatorCurrent).toFixed(2) : "?",
      
      isSolarPowerValid: data.solarPower != undefined && Math.abs(data.solarPower) > 0.01? true : false,
      solarPower: data.solarPower != undefined ? data.solarPower.toFixed(2): "?",
      solarCurrentEqivalent: data.solarCurrentEqivalent != undefined ? data.solarCurrentEqivalent.toFixed(2) : "?",
      
      isLoadCurrentValid: data.loadCurrent != undefined && Math.abs(data.loadCurrent) > 0.01? true : false,
      loadCurrent: data.loadCurrent != undefined ? data.loadCurrent.toFixed(2) : "?",

      isFuelcellNodeConsuming: (data.chargerBatteryCurrent != undefined && Math.abs(data.chargerBatteryCurrent) > 0.01) ? data.chargerBatteryCurrent > 0 : undefined,
      chargerBatteryCurrent: data.chargerBatteryCurrent != undefined ? Math.abs(data.chargerBatteryCurrent).toFixed(2) : "?",
      
      isFuelCellBatteryConsuming: (data.fuelCellBatteryCurrent != undefined && Math.abs(data.fuelCellBatteryCurrent) > 0.01)? data.fuelCellBatteryCurrent< 0: undefined,
      fuelCellBatteryCurrent: data.fuelCellBatteryCurrent != undefined ? Math.abs(data.fuelCellBatteryCurrent).toFixed(2):"?",
      evaCurrent: data.evaCurrent.toFixed(2),

      isCombinationValid: data.fuelCellBatteryCurrent != undefined
    };
    
    //console.log('(constr) Got stromfluss Diagramm data:', this.cData);
    this.initModel(this.cData);
  }

  ngAfterViewInit(): void {
    //console.log('(ngAfterViewInit) ', this.cData);
  }
 
  public onCloseDialogClicked(): void {
    this.dialogRef.close();
  }

  private initModel(data:FuelCellCurrents): void
  {
    var currentDiagramNodes = [
      { id: '1', position: { x: 400, y: 10 }, data: { label: 'Solarpanel' }, type: NodeTemplateType.AvsNodeType},
      { id: '2', position: { x: 400, y: 150 }, data: { label: 'Solarregler' }, type: NodeTemplateType.AvsNodeType},
      { id: '3', position: { x: 10, y: 150 }, data: { label: 'Eva + Router' }, type: NodeTemplateType.AvsNodeType },
      { id: '4', position: { x: 10, y: 300 }, data: { label: 'EFOY' }, type: NodeTemplateType.AvsNodeType },
      { id: '5', position: { x: 10, y: 450 }, data: { label: 'EFOY Akku' }, type: NodeTemplateType.AvsNodeType },
      { id: '6', position: { x: 250, y: 300 }, data: { label: 'Knoten' }, type: NodeTemplateType.ENodeType },
      { id: '7', position: { x: 500, y: 450 }, data: { label: 'DC/DC -> Station' }, type: NodeTemplateType.AvsNodeType },
     ];

    var currentDiagramEdges = [
      {
        id: '1',
        source: '1',
        sourcePort: 'port-bottom',
        targetPort: 'port-top',
        sourceArrowhead: undefined,
        targetArrowhead: 'ng-diagram-arrow',
        target: '2',
        data: {label: data.solarCurrentEqivalent+" A ("+ data?.solarPower +" W)",
              type: data.isSolarPowerValid ? 'pos': 'neutral'
            },
        type: EdgeTemplateType.AvsEdgeType
      },
      {
        id: '2',
        source: '2',
        sourcePort: 'port-bottom',
        targetPort: 'port-right',
        sourceArrowhead: data.isFuelcellNodeConsuming == undefined ? undefined: (data.isFuelcellNodeConsuming == true? undefined:'ng-diagram-arrow'),
        targetArrowhead: data.isFuelcellNodeConsuming == undefined ? undefined: (data.isFuelcellNodeConsuming? 'ng-diagram-arrow':undefined),
        target: '6',
        data: {label: data.chargerBatteryCurrent.toString()+" A",
              type: data.isFuelcellNodeConsuming == undefined ? 'neutral': (data.isFuelcellNodeConsuming == true? 'pos': 'neg')},
        type: EdgeTemplateType.AvsEdgeType
      },
      {
        id: '3',
        source: '3',
        sourcePort: 'port-right',
        targetPort: 'eport-top',
        sourceArrowhead: 'ng-diagram-arrow',
        target: '6',
        data: {label: "~"+ data.evaCurrent+" A",
              type: "neg"},
        type: EdgeTemplateType.AvsEdgeType
      },
      {
        id: '4',
        source: '4',
        sourcePort: 'port-right',
        targetPort: 'port-left',
        sourceArrowhead: data.isGeneratorConsuming == undefined ? undefined: (data.isGeneratorConsuming? 'ng-diagram-arrow': undefined),
        targetArrowhead: data.isGeneratorConsuming == undefined ? undefined: (data.isGeneratorConsuming? undefined: 'ng-diagram-arrow'),
        target: '6',
        data: {label: data.generatorCurrent+" A",
              type: data.isGeneratorConsuming == undefined ? 'neutral': (data.isGeneratorConsuming? 'neg': 'pos')
            },
        type: EdgeTemplateType.AvsEdgeType
      },
      {
        id: '5',
        source: '5',
        sourcePort: 'port-right',
        targetPort: 'eport-bottom',
        sourceArrowhead: data.isFuelCellBatteryConsuming == undefined ? undefined: (data.isFuelCellBatteryConsuming? undefined: 'ng-diagram-arrow'),
        targetArrowhead: data.isFuelCellBatteryConsuming == undefined ? undefined: (data.isFuelCellBatteryConsuming? 'ng-diagram-arrow':undefined),
        target: '6',
        data: {label: "="+data.fuelCellBatteryCurrent+" A",
              type: 'fix'},
        type: EdgeTemplateType.AvsEdgeType
      },
      {
        id: '6',
        source: '2',
        sourcePort: 'port-right',
        targetPort: 'port-top',
        target: '7',
        targetArrowhead: 'ng-diagram-arrow',
        data: {label: data?.loadCurrent+" A",
              type: data.isLoadCurrentValid ? 'neg': 'neutral'},
        type: EdgeTemplateType.AvsEdgeType
      },
    ]
    this.model = initializeModel({
    nodes: currentDiagramNodes,
    edges: currentDiagramEdges
  });
  }
  private formatDateFromISOString(isoString: string): string {
    // ✅ Parse ISO-String korrekt
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).padStart(2, '0');
    return `${day}.${month}.${year}`;
  }
  private formatTimeFromISOString(isoString: string): string {
    // ✅ Parse ISO-String korrekt
    const date = new Date(isoString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  private formatDateTimeFromDate(date: Date): string {
    // ✅ Parse ISO-String korrekt
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month} ${hours}:${minutes}`;
  }
}
